import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SurveyAudiences } from 'src/Models/SurveyAudiences';
import { Surveys } from 'src/Models/Surveys';
import { SurveysResponse } from 'src/Models/SurveysResponse';

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  url: string = environment.API;
  constructor(private http : HttpClient) { }

  postSurveyResponse(id_survey: string, device : any, referral_share_code): Promise<Surveys>{
    const url = `${this.url}Survey/getSurveyResponse/${id_survey}/?referral_share_code=${referral_share_code}`;
    return this.http.post<Surveys>(url, device)
    .toPromise()
    .then(res => { return res })
    .catch(err => { return Promise.reject(err.error || 'Server Error') })
  }

  saveResponse(response: SurveysResponse){
    return this.http.post(`${this.url}${'SurveyResponses/saveSurveyResponse'}`, response)
      .toPromise()      
      .then(res => { return res })
      .catch(err => { return Promise.reject(err.error || 'Server Error') })
  }

  getAudience(id_survey_audience: string, url_survey: string): Promise<SurveyAudiences>{
    return this.http.get<SurveyAudiences>(`${this.url}SurveyAudiences/Audience/${id_survey_audience}?url_survey=${url_survey}`)
      .toPromise()
      .then(res => { return res })
      .catch(err => { return Promise.reject(err.error || 'Server Error') })
  }

  async verifyParticipantAsync(participant_key: string, id_survey: number, identification: string){
    const url =  `${this.url}SurveyResponses/verifyEmail/${participant_key}/${id_survey}?identification=${identification}`;
    return this.http.get<boolean>(url).toPromise()
    .then(res => { return res })
    .catch(err => { return Promise.reject(err.error || 'Server Error') })
  }

  verifyParticipant(participant_key: string, id_survey: number){
    const url =  `${this.url}SurveyResponses/verifyEmail/${participant_key}/${id_survey}`;
    return this.http.get<boolean>(url)
  }

  uploadResponses(idCompany: number, files: File[]): Promise<string[]> {
    const url = `${this.url}Surveys/UploadResponses/${idCompany}`;
    const formData: FormData = new FormData();
  
    files.forEach(file => {
      formData.append('files', file);
    });
  
    return this.http.post<{ urls: string[] }>(url, formData)
      .toPromise()
      .then(res => res.urls)
      .catch(err => Promise.reject(err.error || 'Server Error'));
  }  
}
